import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { logPageView } from "../utils/ga";

/** Sends GA4 page_view on SPA route changes (initial load included). */
export default function GaPageView() {
  const location = useLocation();

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}`;
    const raf = requestAnimationFrame(() => {
      logPageView(pagePath, document.title);
    });
    return () => cancelAnimationFrame(raf);
  }, [location.pathname, location.search]);

  return null;
}
